
import { useEffect, useState } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import mainlogo from "../../Images/vantaralogo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import WishListModal from "../Modal/WishListModal";
import QuickViewModal from "../Modal/QuickViewModal";
import SearchModal from "../Modal/SearchModal";

const NavBar = () => {
  const { cartList } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const location = useLocation();

  const [isFixed, setIsFixed] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false); 
  const [showCategorySidebar, setShowCategorySidebar] = useState(false); 
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({});
  const [expandedCategory, setExpandedCategory] = useState(null); 
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
 const [showModal3, setShowModal3] = useState(false);
  // Get auth token
  const getAuthToken = () => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) return "";
    try {
      const parsed = JSON.parse(userData);
      return parsed.token || "";
    } catch {
      return "";
    }
  };
  const isLoggedIn = !!getAuthToken();
 const [cartLists, setCartList] = useState([]);

   useEffect(() => {
    
    const fetchCart = async () => {
      try {
        const token = getAuthToken(); 

        const response = await axios.get(
          "https://vantara.datacubeglobal.com/api/cart",
          {
            headers: {
              Authorization: `Bearer ${token}`, 
            },
          }
        );

        if (response.data.status === "success") {
          setCartList(response.data.data); 
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    };

    fetchCart();
  }, []);


 useEffect(() => {
  // Fetch categories
  axios.get("https://vantara.datacubeglobal.com/api/api-categories")
    .then(res => {
      if (res.data.status === "success") {
        setCategories(res.data.data);
      }
    })
    .catch(err => console.error(err));


  axios.get("https://vantara.datacubeglobal.com/api/api-sub-categories")
    .then(res => {
      if (res.data.status === "success") {

        const grouped = res.data.data.reduce((acc, sub) => {
          if (!acc[sub.categoy_id]) {
            acc[sub.categoy_id] = [];
          }
          acc[sub.categoy_id].push(sub);
          return acc;
        }, {});
        setSubCategories(grouped);
      }
    })
    .catch(err => console.error(err));
}, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".account-dropdown-trigger") && !event.target.closest(".account-dropdown")) {
        setShowAccountDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY >= 100) setIsFixed(true);
      else if (window.scrollY <= 50) setIsFixed(false);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  useEffect(() => {
    if (showModal2) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [showModal2]);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleOpenQuickView = () => {
    if (location.pathname.includes("/checkout")) {
   
      return;
    }
    setShowModal2(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const toggleAccountDropdown = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      navigate("/account");
      setShowAccountDropdown(false);
    } else {
      setShowAccountDropdown(!showAccountDropdown);
    }
  };

  const handleAccountClick = () => {
    setShowSidebar(false);
    const token = getAuthToken();
    if (!token) {
      navigate("/login");
    } else {
      navigate("/account");
    }
  };

  const currentPath = location.pathname + location.search; // includes query params

  const links = [
    { name: "Home", to: "/" },
    { name: "Product", to: "/shop" },
    { name: "Spices", to: "/shop?category=spices" },
    { name: "Handicrafts", to: "/shop?category=Handicrafts" },
    { name: "Giftings", to: "/shop?category=Giftings" },
    { name: "Wayanad Specials", to: "/shop?category=Wayanad Specials" },
  ];
  return (
    <>
  
      <div className="top-scroller d-none d-md-block">
        <div className="scroll-wrapper">
          <div className="scroll-text">
            &nbsp;&nbsp;&nbsp;12-3333-4567 &nbsp;&nbsp;&nbsp; Vantara@gmail.com
            &nbsp;&nbsp;&nbsp; <span className="underline-white">Our Store</span>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <Navbar fixed="top" expand="md" className={isFixed ? "shadow-sm bg-white" : "bg-white"}>
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/">
            <img src={mainlogo} alt="VANTHARA Logo" style={{ height: "30px" ,marginBottom:'10px'}} />
          </Navbar.Brand>

          {/* Desktop nav */}
          <Nav className="mx-auto d-none d-md-flex gap-3">
      {links.map((link) => (
        <Nav.Link
          key={link.to}
          as={Link}
          to={link.to}
          className={`text-dark ${currentPath === link.to ? "active" : ""}`}
          style={{ fontSize: "16px" }}
        >
          {link.name}
        </Nav.Link>
      ))}
    </Nav>
          {/* Desktop right icons */}
   
{/* <div 
  className="d-none d-md-flex align-items-center gap-2"
  style={{ 
    minHeight: '48px',        
    overflow: 'visible'        
  }}
>
  <div className="position-relative" style={{ padding: '8px' }}>
    <i className="bi bi-search fs-5 fw-bold"></i>
  </div>

  <div className="position-relative" style={{ padding: '8px' }}>
    <Link 
      to="#" 
      className="text-dark fw-bold account-dropdown-trigger d-inline-block"
      onClick={toggleAccountDropdown}
      // style={{ lineHeight: 1 }}
    >
      <i className="bi bi-person fs-5 fw-bold"></i>
    </Link>
  </div>

  <div className="position-relative" style={{ padding: '8px' }}>
   <Link
  to="#"
  className="text-dark position-relative d-inline-block"
  onClick={handleOpenQuickView}
>
  <i className="bi bi-bag fs-5 fw-bold"></i>

  {cartLists?.length > 0 && (
    <span
      className="position-absolute badge rounded-pill"
      style={{
        fontSize: "12px",
        minWidth: "20px",
        height: "20px",
        lineHeight: "20px",
        padding: "0 6px",
        backgroundColor: "#7c0046",
        color: "#fff",
        fontWeight: "bold",
        border: "1px solid #fff",
        top: "0",         
        right: "0",       
        transform: "translate(50%, -50%)", 
        zIndex: 10,
        textAlign: "center",
        pointerEvents: "none",
      }}
    >
      {cartLists.length}
    </span>
  )}
</Link>

  </div>

  <div className="position-relative" style={{ padding: '8px' }}>
    <Link to="/wishlist" className="text-dark fw-bold d-inline-block" style={{ lineHeight: 1 }}>
      <i className="bi bi-heart fs-5 fw-bold"></i>
    </Link>
  </div>
</div> */}
<div className="d-none d-md-flex align-items-center gap-3">
  <div className="icon-btn">
    <i className="bi bi-search"  onClick={() => setShowModal3(true)} style={{ cursor: "pointer" }}></i>
  </div>

  <Link 
    to="#" 
    className="text-dark account-dropdown-trigger icon-btn fs-5"
    onClick={toggleAccountDropdown}
  >
    <i className="bi bi-person"></i>
  </Link>

  <Link
    to="#"
    className="text-dark position-relative icon-btn"
    onClick={handleOpenQuickView}
  >
    <i className="bi bi-bag"></i>
    {cartLists?.length > 0 && (
      <span className="position-absolute badge rounded-pill"
        style={{
          fontSize: "12px",
          minWidth: "20px",
          height: "20px",
          lineHeight: "20px",
          padding: "0 6px",
          backgroundColor: "#7c0046",
          color: "#fff",
          fontWeight: "bold",
          border: "1px solid #fff",
          top: "0",
          right: "0",
          transform: "translate(50%, -50%)",
          zIndex: 10,
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        {cartLists.length}
      </span>
    )}
  </Link>

  <Link to="/wishlist" className="text-dark icon-btn">
    <i className="bi bi-heart"></i>
  </Link>
</div>


          {/* Mobile sidebar toggle */}
          <div className="d-md-none">
            <Navbar.Toggle aria-controls="sidebar-nav" onClick={() => setShowSidebar(true)} />
          </div>
        </Container>
      </Navbar>

{showAccountDropdown && !isLoggedIn && (
  <div 
    className="account-dropdown" 
    style={{
      position: "fixed", // Changed from absolute to fixed
      top: isFixed ? "70px" : "110px", // Adjust based on scroll state
      right: "20px",
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      padding: "16px",
      zIndex: 1050,
      minWidth: "180px",
      textAlign: "center"
    }}
  >
    <button
      style={{
        width: "100%",
        padding: "10px",
        background: "#1c3f1d",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: "14px"
      }}
      onClick={() => { 
        setShowAccountDropdown(false); 
        navigate("/login"); 
      }}
    >
      LOGIN
    </button>
    <div style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
      New here? <Link to="/register" style={{ color: "#000", fontWeight: "bold", textDecoration: "none" }}>Register</Link>
    </div>
  </div>
)}
      {/* Existing Sidebar */}
      <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start" className="d-md-none sidebar-white">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><img src={mainlogo} alt="VANTHARA Logo" style={{ height: "35px" }} /></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column fw-semibold">
            <Nav.Link as={Link} to="/" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Home</Nav.Link>
            <Nav.Link as={Link} to="/shop" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Products</Nav.Link>
            <Nav.Link as={Link} to="/shop?category=spices"  onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Spices</Nav.Link>
            <Nav.Link as={Link} to="/shop?category=Handicrafts"  onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Handicrafts</Nav.Link>
            <Nav.Link as={Link} to="/shop?category=Giftings" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Giftings</Nav.Link>
            <Nav.Link as={Link} to="/shop?category=Wayanad Specials" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Wayanad Specials</Nav.Link>
                       <Nav.Link
  as={Link}
  to={getAuthToken() ? "/account" : "/login"}
  className="text-dark py-3 border-bottom"
>
  Account
</Nav.Link>
         <Nav.Link    as={Link}
     to="/wishlist" className="text-dark py-3 border-bottom">Wishlist</Nav.Link>
          </Nav>
          
        </Offcanvas.Body>
      </Offcanvas>
      {/* Category Sidebar with Subcategories */}
{/* Category Sidebar with Subcategories */}
<Offcanvas
  show={showCategorySidebar}
  onHide={() => setShowCategorySidebar(false)}
  placement="start"
  className="d-md-none sidebar-white"
>
  <Offcanvas.Header closeButton>
    <Offcanvas.Title>
      <img src={mainlogo} alt="VANTHARA Logo" style={{ height: "35px", width: "auto" }} />
    </Offcanvas.Title>
  </Offcanvas.Header>
  <Offcanvas.Body>
   
    <Nav className="flex-column fw-semibold">
  {categories.map(cat => {
    const filteredSubCats = subCategories[cat.id]?.filter(
      sub => sub.categoy_id === cat.id
    ) || [];

    const hasSubCats = filteredSubCats.length > 0;

    return (
      <div key={cat.id}>
       
        <Nav.Link
          as={Link}
          to={`/products/${cat.id}`}   
          onClick={() => {
            if (hasSubCats) {
            
              setExpandedCategory(expandedCategory === cat.id ? null : cat.id);
            } else {
              setShowCategorySidebar(false);
            }
          }}
          className="text-dark py-3 border-bottom d-flex justify-content-between align-items-center"
        >
          {cat.name}
 
          {hasSubCats && <span>{expandedCategory === cat.id ? "−" : "+"}</span>}
        </Nav.Link>

        {/* Subcategories */}
        {expandedCategory === cat.id && hasSubCats && (
          <div className="ms-3">
            {filteredSubCats.map(subCat => (
              <Nav.Link
                key={subCat.id}
                as={Link}
                to={`/products/${subCat.id}`}  
                onClick={() => setShowCategorySidebar(false)}
                className="text-dark py-2"
              >
                {subCat.sub_cat_name}
              </Nav.Link>
            ))}
          </div>
        )}
      </div>
    );
  })}
</Nav>

  </Offcanvas.Body>
</Offcanvas>


      {/* Bottom Navbar */}
      <Navbar fixed="bottom" bg="white" variant="light" className="d-md-none border-top shadow-sm">
        <Nav className="w-100 d-flex justify-content-around text-center">
          <Nav.Item>
            <Nav.Link as={Link} to="/" className="text-dark">
              <i className="bi bi-house fs-8"></i>
              <div className="small">Home</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/shop" className="text-dark">
              <i className="bi bi-grid fs-8"></i>
              <div className="small">Product</div>
            </Nav.Link>
          </Nav.Item>
            <Nav.Item>
            <Nav.Link className="text-dark" onClick={() => setShowModal3(true)}>
              <i className="bi bi-search fs-8"></i>
              <div className="small">Search</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="text-dark" onClick={() => setShowCategorySidebar(true)}>
              <i className="bi bi-list fs-8"></i>
              <div className="small">Categories</div>
            </Nav.Link>
          </Nav.Item>


          {/* <Nav.Item>
            <Nav.Link className="text-dark" onClick={handleOpenModal}>
              <i className="bi bi-heart fs-8"></i>
              <div className="small">Wishlist</div>
            </Nav.Link>
          </Nav.Item> */}
        <Nav.Item className="position-relative">
  <Nav.Link className="text-dark" onClick={handleOpenQuickView}>
    <i className="bi bi-bag fs-8"></i>
    {cartLists?.length > 0 && (
      <span
        className="position-absolute top-0 start-100 translate-middle badge rounded-pill "
          style={{ 
      fontSize: "12px", 
      minWidth: "18px", 
      backgroundColor: "#7c0046", 
      color: "#fff"               
    }}

      >
        {cartLists.length}
      </span>
    )}
    <div className="small">Cart</div>
  </Nav.Link>
</Nav.Item>
        </Nav>
      </Navbar>

      <WishListModal show={showModal} onHide={handleCloseModal} />
      <QuickViewModal show={showModal2} onHide={() => setShowModal2(false)} />
 <SearchModal show={showModal3} handleClose={() => setShowModal3(false)} />
    
      <style>{`

              .top-scroller {
          background: #1c3f1d;
          color: #fff;
          font-size: 16px;
          font-weight: 900;
          height: 45px;
          line-height: 40px;
          overflow: hidden;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
         z-index: 1000;
        }
        .scroll-wrapper {
          display: flex;
          width: max-content;
         
        }
          .nav-link.active {
  color: #7B0046 !important; /* your active color */
  font-weight: bold !important;
}
          .underline-white {
  text-decoration: underline;
  text-decoration-color: #fff; /* white underline */
  text-underline-offset: 2px; /* optional: offset for better spacing */
}
        .scroll-text {
          padding-right: 50px;
          white-space: nowrap;
        }
        @keyframes scrollText {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

  /* Sidebar (Mobile) */
  .sidebar-white {
    color: #000 !important;
    padding: 14px 0 !important;
    font-size: 18px;   /* increased from 16px */
    border-bottom: 1px solid #eee;
  }

  /* Desktop nav links */
  .desktop-nav .nav-link,
  .navbar .nav-link {
    padding: 0 14px;
    font-size: 18px;   /* increased font size */
    font-weight: 500;
  }

  /* Icons text in mobile bottom nav */
  .navbar .small {
    font-size: 14px;   /* increased from bootstrap default */
    font-weight: 500;
  }

  /* Sidebar links */
  .sidebar-white .nav-link {
    color: #000 !important;
    font-size: 18px;   /* increased from 16px */
    font-weight: 800 !important;
  }

  .plus-icon {
    font-size: 28px;  
    font-weight: bold;
    line-height: 1;
  }
.navbar.fixed-top {
  top: 0 !important;
}

/* Only desktop, push below the top-scroller */
@media (min-width: 768px) {
  .navbar.fixed-top {
    top: 38px !important;
  }
}
  /* Mobile Sidebar width */
  @media (max-width: 767px) {
    .offcanvas.sidebar-white.offcanvas-start {
      width: 90% !important;
      max-width: 90% !important;
    }
  }
        .sidebar-white { color: #000 !important; font-size: 18px; }
        .plus-icon { font-size: 28px; font-weight: bold; }
        .navbar.fixed-top { top: 0 !important; }
        @media (min-width: 768px) { .navbar.fixed-top { top: 38px !important; } }
        @media (max-width: 767px) { .offcanvas.sidebar-white.offcanvas-start { width: 90% !important; max-width: 90% !important; } }
      `}</style>
    </>
  );
};

export default NavBar;




// import { useEffect, useState } from "react";
// import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import mainlogo from "../../Images/vantaralogo.png";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import WishListModal from "../Modal/WishListModal";
// import QuickViewModal from "../Modal/QuickViewModal";

// const NavBar = () => {
//   const { cartList } = useSelector((state) => state.cart);
//   const navigate = useNavigate();

//   const [isFixed, setIsFixed] = useState(false);
//   const [showSidebar, setShowSidebar] = useState(false); // Existing sidebar
//   const [showCategorySidebar, setShowCategorySidebar] = useState(false); // Categories sidebar
//   const [showModal, setShowModal] = useState(false);
//   const [showModal2, setShowModal2] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState({});
//   const [expandedCategory, setExpandedCategory] = useState(null); // For expand/collapse subcategories
//   const [showAccountDropdown, setShowAccountDropdown] = useState(false);

//   // Get auth token
//   const getAuthToken = () => {
//     const userData = sessionStorage.getItem("userData");
//     if (!userData) return "";
//     try {
//       const parsed = JSON.parse(userData);
//       return parsed.token || "";
//     } catch {
//       return "";
//     }
//   };
//   const isLoggedIn = !!getAuthToken();
//  const [cartLists, setCartList] = useState([]);

//    useEffect(() => {
//     // Fetch cart data from API
//     const fetchCart = async () => {
//       try {
//         const token = getAuthToken(); // Get token from sessionStorage

//         const response = await axios.get(
//           "https://vantara.datacubeglobal.com/api/cart",
//           {
//             headers: {
//               Authorization: `Bearer ${token}`, // Pass token in header
//             },
//           }
//         );

//         if (response.data.status === "success") {
//           setCartList(response.data.data); // Set the cart items
//         }
//       } catch (error) {
//         console.error("Error fetching cart:", error);
//       }
//     };

//     fetchCart();
//   }, []);


//   // Fetch categories and subcategories
//   useEffect(() => {
//     axios.get("https://vantara.datacubeglobal.com/api/api-categories")
//       .then(res => {
//         if (res.data.status === "success") {
//           setCategories(res.data.data);
//           // Fetch subcategories for each category
//           res.data.data.forEach(cat => {
//             axios.get(`https://vantara.datacubeglobal.com/api/sub-categories?categoy_id=${cat.id}`)
//               .then(subRes => {
//                 if (subRes.data.status === "success") {
//                   setSubCategories(prev => ({
//                     ...prev,
//                     [cat.id]: subRes.data.data
//                   }));
//                 }
//               });
//           });
//         }
//       })
//       .catch(err => console.error(err));
//   }, []);

//   // Handle account dropdown outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (!event.target.closest(".account-dropdown-trigger") && !event.target.closest(".account-dropdown")) {
//         setShowAccountDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Fixed header on scroll
//   useEffect(() => {
//     const scrollHandler = () => {
//       if (window.scrollY >= 100) setIsFixed(true);
//       else if (window.scrollY <= 50) setIsFixed(false);
//     };
//     window.addEventListener("scroll", scrollHandler);
//     return () => window.removeEventListener("scroll", scrollHandler);
//   }, []);

//   // Disable scroll when modals open
//   useEffect(() => {
//     if (showModal2) {
//       document.body.style.overflow = "hidden";
//       document.documentElement.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//       document.documentElement.style.overflow = "";
//     }
//   }, [showModal2]);

//   const handleOpenModal = (e) => {
//     e.preventDefault();
//     setShowModal(true);
//   };

//   const handleOpenQuickView = () => setShowModal2(true);
//   const handleCloseModal = () => setShowModal(false);

//   const toggleAccountDropdown = (e) => {
//     e.preventDefault();
//     if (isLoggedIn) {
//       navigate("/account");
//       setShowAccountDropdown(false);
//     } else {
//       setShowAccountDropdown(!showAccountDropdown);
//     }
//   };

//   return (
//     <>
//       {/* Top scroller */}
//       <div className="top-scroller d-none d-md-block">
//         <div className="scroll-wrapper">
//           <div className="scroll-text">
//             &nbsp;&nbsp;&nbsp;12-3333-4567 &nbsp;&nbsp;&nbsp; Vantara@gmail.com
//             &nbsp;&nbsp;&nbsp; <span className="underline-white">Our Store</span>
//           </div>
//         </div>
//       </div>

//       {/* Navbar */}
//       <Navbar fixed="top" expand="md" className={isFixed ? "shadow-sm bg-white" : "bg-white"}>
//         <Container className="d-flex justify-content-between align-items-center">
//           {/* Logo */}
//           <Navbar.Brand as={Link} to="/">
//             <img src={mainlogo} alt="VANTHARA Logo" style={{ height: "40px" }} />
//           </Navbar.Brand>

//           {/* Desktop nav */}
//           <Nav className="mx-auto d-none d-md-flex  gap-4">
//            <Nav.Link as={Link} to="/" className="text-dark" style={{ fontSize: "16px" }}>Home</Nav.Link>
//   <Nav.Link as={Link} to="/shop" className="text-dark" style={{ fontSize: "16px" }}>Product</Nav.Link>
//   <Nav.Link as={Link} to="/about" className="text-dark" style={{ fontSize: "16px" }}>Spices</Nav.Link>
//   <Nav.Link as={Link} to="/wishlist" className="text-dark" style={{ fontSize: "16px" }}>Handicrafts</Nav.Link>
//   <Nav.Link as={Link} to="/faq" className="text-dark" style={{ fontSize: "16px" }}>Giftings</Nav.Link>
//   <Nav.Link as={Link} to="/faq" className="text-dark" style={{ fontSize: "16px" }}>Wayanad Specials</Nav.Link>
//             {/* <Nav.Link as={Link} to="/about" className="text-dark ">About Us</Nav.Link>
//             <Nav.Link as={Link} to="/wishlist" className="text-dark ">WishList</Nav.Link>
//             <Nav.Link as={Link} to="/faq" className="text-dark ">FAQ</Nav.Link> */}
//           </Nav>

//           {/* Desktop right icons */}
//           <div className="d-none d-md-flex align-items-center gap-3">
//             <i className="bi bi-search fs-5 fw-bold"></i>
//             <Link to="#" className="text-dark fw-bold account-dropdown-trigger" onClick={toggleAccountDropdown}>
//               <i className="bi bi-person fs-5 fw-bold"></i>
//             </Link>
//             <Link to="/wishlist" className="text-dark fw-bold">
//               <i className="bi bi-heart fs-5 fw-bold"></i>
//             </Link>
//     <Link
//   to="#"
//   className="text-dark position-relative d-inline-block"
//   onClick={handleOpenQuickView}
// >
//   <i className="bi bi-bag fs-5 fw-bold"></i>
//   {console.log(cartLists)}
//   {cartLists?.length > 0 && (
//     <span
//       className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//       style={{ fontSize: "12px", minWidth: "18px" }}
//     >
//       {cartLists.length}
//     </span>
//   )}
// </Link>

//           </div>

//           {/* Mobile sidebar toggle */}
//           <div className="d-md-none">
//             <Navbar.Toggle aria-controls="sidebar-nav" onClick={() => setShowSidebar(true)} />
//           </div>
//         </Container>
//       </Navbar>

//       {/* Account dropdown */}
//       {showAccountDropdown && !isLoggedIn && (
//         <div className="account-dropdown" style={{
//           position: "absolute",
//           top: "80px",
//           right: "20px",
//           backgroundColor: "#fff",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//           padding: "16px",
//           zIndex: 1050,
//           minWidth: "180px",
//           textAlign: "center"
//         }}>
//           <button
//             style={{
//               width: "100%",
//               padding: "10px",
//               background: "#000",
//               color: "#fff",
//               border: "none",
//               borderRadius: "4px",
//               cursor: "pointer",
//               fontWeight: "bold",
//               fontSize: "14px"
//             }}
//             onClick={() => { setShowAccountDropdown(false); navigate("/login"); }}
//           >
//             LOGIN
//           </button>
//           <div style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
//             New here? <Link to="/register" style={{ color: "#000", fontWeight: "bold", textDecoration: "none" }}>Register</Link>
//           </div>
//         </div>
//       )}

//       {/* Existing Sidebar */}
//       <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start" className="d-md-none sidebar-white">
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title><img src={mainlogo} alt="VANTHARA Logo" style={{ height: "35px" }} /></Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Nav className="flex-column fw-semibold">
//             <Nav.Link as={Link} to="/" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Home</Nav.Link>
//             <Nav.Link as={Link} to="/about" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">About Us</Nav.Link>
//             <Nav.Link as={Link} to="/shop" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Shop</Nav.Link>
//             <Nav.Link as={Link} to="/checkout" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Cart</Nav.Link>
//             <Nav.Link as={Link} to="/wishlist" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Wishlist</Nav.Link>
//             <Nav.Link as={Link} to="/account" onClick={() => setShowSidebar(false)} className="text-dark py-3 border-bottom">Account</Nav.Link>
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>

//       {/* Category Sidebar with Subcategories */}
// {/* Category Sidebar with Subcategories */}
// <Offcanvas
//   show={showCategorySidebar}
//   onHide={() => setShowCategorySidebar(false)}
//   placement="start"
//   className="d-md-none sidebar-white"
// >
//   <Offcanvas.Header closeButton>
//     <Offcanvas.Title>
//       <img src={mainlogo} alt="VANTHARA Logo" style={{ height: "35px", width: "auto" }} />
//     </Offcanvas.Title>
//   </Offcanvas.Header>
//   <Offcanvas.Body>
//     <Nav className="flex-column fw-semibold">
//       {categories.map(cat => {
//         const filteredSubCats = subCategories[cat.id]?.filter(sub => sub.categoy_id === cat.id);
//         return (
//           <div key={cat.id}>
//             <Nav.Link
//               onClick={() => setExpandedCategory(expandedCategory === cat.id ? null : cat.id)}
//               className="text-dark py-3 border-bottom d-flex justify-content-between align-items-center"
//             >
//               {cat.name} <span>+</span>
//             </Nav.Link>

//             {expandedCategory === cat.id && filteredSubCats && filteredSubCats.length > 0 && (
//               <div className="ms-3">
//                 {filteredSubCats.map(subCat => (
//                   <Nav.Link
//                     key={subCat.id}
//                     as={Link}
//                     to={`/products_by_subcategory/${subCat.id}`}
//                     onClick={() => setShowCategorySidebar(false)}
//                     className="text-dark py-2"
//                   >
//                     {subCat.sub_cat_name}
//                   </Nav.Link>
//                 ))}
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </Nav>
//   </Offcanvas.Body>
// </Offcanvas>


//       {/* Bottom Navbar */}
//       <Navbar fixed="bottom" bg="white" variant="light" className="d-md-none border-top shadow-sm">
//         <Nav className="w-100 d-flex justify-content-around text-center">
//           <Nav.Item>
//             <Nav.Link as={Link} to="/" className="text-dark">
//               <i className="bi bi-house fs-5"></i>
//               <div className="small">Home</div>
//             </Nav.Link>
//           </Nav.Item>
//           <Nav.Item>
//             <Nav.Link as={Link} to="/shop" className="text-dark">
//               <i className="bi bi-grid fs-5"></i>
//               <div className="small">Product</div>
//             </Nav.Link>
//           </Nav.Item>
//           <Nav.Item>
//             <Nav.Link className="text-dark" onClick={() => setShowCategorySidebar(true)}>
//               <i className="bi bi-list fs-5"></i>
//               <div className="small">Categories</div>
//             </Nav.Link>
//           </Nav.Item>
//           <Nav.Item>
//             <Nav.Link className="text-dark" onClick={handleOpenModal}>
//               <i className="bi bi-heart fs-5"></i>
//               <div className="small">Wishlist</div>
//             </Nav.Link>
//           </Nav.Item>
//         <Nav.Item className="position-relative">
//   <Nav.Link className="text-dark" onClick={handleOpenQuickView}>
//     <i className="bi bi-bag fs-5"></i>
//     {cartLists?.length > 0 && (
//       <span
//         className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//         style={{ fontSize: "12px", minWidth: "18px" }}
//       >
//         {cartLists.length}
//       </span>
//     )}
//     <div className="small">Cart</div>
//   </Nav.Link>
// </Nav.Item>
//         </Nav>
//       </Navbar>

//       {/* Modals */}
//       <WishListModal show={showModal} onHide={handleCloseModal} />
//       <QuickViewModal show={showModal2} onHide={() => setShowModal2(false)} />

//       {/* Sidebar CSS */}
//       <style>{`

//               .top-scroller {
//           background: #000;
//           color: #fff;
//           font-size: 16px;
//           font-weight: 900;
//           height: 45px;
//           line-height: 40px;
//           overflow: hidden;
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//          z-index: 1000;
//         }
//         .scroll-wrapper {
//           display: flex;
//           width: max-content;
         
//         }
//           .underline-white {
//   text-decoration: underline;
//   text-decoration-color: #fff; /* white underline */
//   text-underline-offset: 2px; /* optional: offset for better spacing */
// }
//         .scroll-text {
//           padding-right: 50px;
//           white-space: nowrap;
//         }
//         @keyframes scrollText {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }

//   /* Sidebar (Mobile) */
//   .sidebar-white {
//     color: #000 !important;
//     padding: 14px 0 !important;
//     font-size: 18px;   /* increased from 16px */
//     border-bottom: 1px solid #eee;
//   }

//   /* Desktop nav links */
//   .desktop-nav .nav-link,
//   .navbar .nav-link {
//     padding: 0 14px;
//     font-size: 18px;   /* increased font size */
//     font-weight: 500;
//   }

//   /* Icons text in mobile bottom nav */
//   .navbar .small {
//     font-size: 14px;   /* increased from bootstrap default */
//     font-weight: 500;
//   }

//   /* Sidebar links */
//   .sidebar-white .nav-link {
//     color: #000 !important;
//     font-size: 18px;   /* increased from 16px */
//     font-weight: 800 !important;
//   }

//   .plus-icon {
//     font-size: 28px;  
//     font-weight: bold;
//     line-height: 1;
//   }
// .navbar.fixed-top {
//   top: 0 !important;
// }

// /* Only desktop, push below the top-scroller */
// @media (min-width: 768px) {
//   .navbar.fixed-top {
//     top: 38px !important;
//   }
// }
//   /* Mobile Sidebar width */
//   @media (max-width: 767px) {
//     .offcanvas.sidebar-white.offcanvas-start {
//       width: 90% !important;
//       max-width: 90% !important;
//     }
//   }
//         .sidebar-white { color: #000 !important; font-size: 18px; }
//         .plus-icon { font-size: 28px; font-weight: bold; }
//         .navbar.fixed-top { top: 0 !important; }
//         @media (min-width: 768px) { .navbar.fixed-top { top: 38px !important; } }
//         @media (max-width: 767px) { .offcanvas.sidebar-white.offcanvas-start { width: 90% !important; max-width: 90% !important; } }
//       `}</style>
//     </>
//   );
// };

// export default NavBar;



